import { useState } from 'react';
import { Button, Divider, Input, Modal } from 'antd';
import { apiDeleteProviderDataSponsorScheduler } from '../../api';
import {
    DeleteProviderSchedulerRequest,
    ProviderSchedulerItem
} from '../../interfaces/provider-data-sponsor-scheduler.interface';
import { systemProviderDataSponsorOptions } from '../../assets/constants/default_option';
import { toastError, toastSuccess } from '../../utils/toast';
import { useLoading } from '../../context/LoadingContext';

interface ModalDeleteProviderSchedulerProps {
    open: boolean;
    items: ProviderSchedulerItem[];
    onClose: () => void;
    onSuccess: () => void;
    title?: string;
    providerOptions?: { label: string; value: string }[];
    deleteApi?: (params?: any) => Promise<any>;
    successMessage?: string;
    description?: string;
}

const defaultProviderOptions = systemProviderDataSponsorOptions.filter(item => item.value !== '');

export default function ModalDeleteProviderScheduler({
    open,
    items,
    onClose,
    onSuccess,
    title = 'Xoá lịch đổi nhà cung cấp đại trà',
    providerOptions = defaultProviderOptions,
    deleteApi = apiDeleteProviderDataSponsorScheduler,
    successMessage = 'Đã xoá lịch đổi nhà cung cấp đại trà',
    description = 'Lịch đổi nhà cung cấp đại trà sẽ dừng ngay sau khi xoá.',
}: ModalDeleteProviderSchedulerProps) {
    const [otpConfirm, setOtpConfirm] = useState('');
    const { setIsLoading } = useLoading();

    const handleCancel = () => {
        setOtpConfirm('');
        onClose();
    };

    const handleDelete = async () => {
        try {
            if (!otpConfirm) {
                return toastError('Vui lòng nhập mã OTP xác nhận');
            }
            const payload: DeleteProviderSchedulerRequest = { otpConfirm };
            setIsLoading(true);
            const resp = await deleteApi(payload);
            if (resp.status === 200) {
                toastSuccess(successMessage);
                setOtpConfirm('');
                onSuccess();
                onClose();
            }
        } catch (error) {
            toastError('Có lỗi xảy ra');
            console.log(error);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <Modal
            title={title}
            open={open}
            onCancel={handleCancel}
            footer={[
                <Button key="delete" onClick={handleDelete} type="primary" danger>
                    Xoá
                </Button>
            ]}
        >
            <p>{description}</p>
            {items.map(item => (
                <p key={item.time}><b>{item.time}</b>: {providerOptions.find(option => option.value === item.provider)?.label || item.provider}</p>
            ))}
            <p><span style={{ color: 'red' }}>*</span> Nhập mã OTP xác nhận</p>
            <Input value={otpConfirm} onChange={e => setOtpConfirm(e.target.value)} />
            <Divider />
        </Modal>
    );
}
